export default __webpack_public_path__ + "static/media/vegan.97da9685.jpg";